import api from './client.js'

export const raffleAPI = {
  getMine: () => api.get('/raffle/mine'),
  adminListUsers: () => api.get('/raffle/admin/users'),
  adminListForUser: (userId) => api.get(`/raffle/admin/users/${userId}`),
  adminRedeem: (id, note) => api.post(`/raffle/admin/tickets/${id}/redeem`, { note }),
  adminUnredeem: (id) => api.post(`/raffle/admin/tickets/${id}/unredeem`),
  adminReconcile: () => api.post('/raffle/admin/reconcile'),
  adminDeleteTicket: (id) => api.delete(`/raffle/admin/tickets/${id}`),
  adminDeleteAllForUser: (userId) => api.delete(`/raffle/admin/users/${userId}/tickets`),
}
